<template>
    <v-form v-if="showDocument" ref="systemPageForm">
        <v-container>
            <v-row>
                <v-col cols="12" md="6" order-md="2">
                    <div class="d-flex justify-center justify-md-end">
                        <action-buttons
                            :state="editState"
                            :permission="userPermission"
                            :disabled="disableButtons"
                            @save="handleSave"
                            @cancel="handleCancel"
                            @close="handleClose"
                            :is-dirty="isDirty"
                            class="d-flex justify-end"
                        />
                    </div>
                </v-col>
                <v-col cols="12" md="6" order-md="1" v-if="id">
                    <last-edit-details :entity="doc" />
                </v-col>
            </v-row>
            <v-row v-if="errorMessage" justify>
                <v-col>
                    <v-alert type="error">
                        {{ errorMessage }}
                    </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.name" label="Plot Name" :rules="[requiredRule]">
                        <template v-slot:[`label`]>
                            <label-required name="Name" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <large-text-editor
                        v-model="doc.details"
                        label="Content"
                        :rules="[requiredRule]"
                    ></large-text-editor>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>
<script>
import api from '@/api'
import { mapState, mapGetters } from 'vuex'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import editorMixin from '../../mixins/editorMixin'
import RequiresLabel from '../../components/RequiredLabel'
export default {
    name: 'ResearchRequestEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    components: {
        'label-required': RequiresLabel,
    },
    props: {
        id: {
            type: [Number, String],
            required: false,
            validator: value => {
                return !!value
            },
        },
    },
    data() {
        return {
            doc: null,
            errorMessage: '',
            requiredRule: v => !!v || 'Required',
        }
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['events', 'nextEvent', 'userTeams']),
        userPermission() {
            if (this.user && this.user.research && this.doc && this.doc.teamId) {
                return this.user.teams.includes(this.doc.teamId) ? this.user.research.owned : this.user.research.shared
            } else if (this.user && this.user.research) {
                return this.user.research.owned
            } else {
                return 0
            }
        },
        showDocument() {
            return !this.isLoading && this.doc
        },
        editState() {
            return this.id ? 'Edit' : 'Create'
        },
        teamCount() {
            return this.user && this.user.teams ? this.user.teams.length : 1
        },
        showTeamPicker() {
            return this.teamCount > 1 || this.user.research.all > 1
        },
        userDefaultTeamId() {
            if (this.user && this.user.defaultTeam) {
                let teamId = parseInt(this.user.defaultTeam)
                if (!isNaN(teamId)) return teamId
            }
            return this.user && this.user.teams ? this.user.teams[0] : 0
        },
        teams() {
            return this.userTeams('research')
        },
    },
    watch: {
        id(newVal) {
            if (newVal) {
                this.getLammieRequest()
            }
        },
        doc: {
            deep: true,
            handler(newVer, oldVer) {
                this.isDirty = newVer && oldVer ? newVer.version === oldVer.version : false
            },
        },
    },
    mounted() {
        if (this.id) {
            this.getSystemPages()
        } else {
            this.doc = {
                characterName: '',
                playerName: '',
                notes: '',
                reference: '',
                researchPeriodId: 0,
                teamId: 0,
                topic: '',
                url: '',
            }
        }
    },
    methods: {
        getSystemPages() {
            this.isLoading = true
            api.get(`/systemPages/${this.$route.params.id}`)
                .then(res => {
                    this.doc = res
                })
                .finally(() => {
                    this.isLoading = false
                    this.isDirty = false
                })
        },
        handleSave() {
            if (!this.$refs.systemPageForm.validate()) return
            this.isSaving = true
            if (this.id) {
                api.put(`/systemPage/${this.id}`, this.doc)
                    .then(res => {
                        this.doc = res
                        this.showSnackbar('success', 'System Page Saved')
                    })
                    .catch(res => {
                        if (res.err.response && res.err.response.status === 409) {
                            this.errorMessage =
                                'System Page has been updated elsewhere - this is not the most recent verions.  Please reload doc'
                        }
                    })
                    .finally(() => {
                        this.isSaving = false
                    })
            } else {
                if (this.teamCount == 1) {
                    this.doc.teamId = this.userDefaultTeamId
                }
                api.post(`/systemPage`, this.doc)
                    .then(res => {
                        this.showSnackbar('success', 'System Page Created')
                        this.isDirty = false
                        this.$router.push({ name: 'readSystemPage', params: { id: res } })
                    })
                    .finally(() => (this.isSaving = false))
            }
        },
        handleCancel() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        handleClose() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
    },
}
</script>
